export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const SET_USER_PROFILE = "SET_USER_PROFILE";

export const SET_BUSINESS_PROFILE = "SET_BUSINESS_PROFILE";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
